import moment from 'moment';

import { ResourceActiveDisabled, ResourceActiveEnabled } from '~/src/dash/api/console-api';
import { IDeal, ISamsungDealParams } from '~/src/dash/api/deals';

// activeStatusChangeHandler handles the logic where the status of a Samsung deal needs to be changed when we change its
// active value.
// - If the deal is set to inactive, and its status is PENDING/RUNNING, then its status will be changed to PAUSED.
// - If the deal is set to active, and its status is PAUSED, then its status will be changed to PENDING/RUNNING.
export function dealActiveStatusChangeHandler(deal: IDeal) {
  const samsungParams = deal.SspParams as ISamsungDealParams;

  // if the deal active status is changed to inactive and its status is PENDING/RUNNING, then change it to PAUSED
  if (
    deal.Active === ResourceActiveDisabled &&
    (samsungParams.status === 'PENDING' || samsungParams.status === 'RUNNING')
  ) {
    samsungParams.status = 'PAUSED';
  }

  // if the deal active status is changed to active, and its status is PAUSED, then change it to PENDING/RUNNING
  if (deal.Active === ResourceActiveEnabled && samsungParams.status === 'PAUSED') {
    // if deal start date is in the past, then set the status to RUNNING; else PENDING
    if (moment(deal.StartDate).isBefore()) {
      samsungParams.status = 'RUNNING';
    } else {
      samsungParams.status = 'PENDING';
    }
  }
}
